import { compact, omit } from "lodash";
import { FindingStats } from "types/api/findingStats";

import { formatNumber } from "./numberUtil";

export type OptionTypeV3 = {
  id: string | number;
  name: string;
  count?: number;
};

export type OptionType = {
  id: string | number;
  name: string;
};

export type CountType = {
  id?: OptionType["id"];
  count?: number;
};

export const getOptionsWithCount = (
  values: OptionType[],
  counts: CountType[] = [],
) => {
  return values.map(({ name, id }) => ({
    name,
    id,
    secondaryText: formatNumber(
      counts.find((stat) => stat.id && (stat.id === id || +stat.id === id))
        ?.count ?? 0,
    ),
  }));
};

/**
 * @param response The FindingStats object to convert to count list to show count in filters.
 * @returns An array of objects with id and count keys.
 */
export const convertFindingStatsToCount = (response: FindingStats) => {
  return Object.values(omit(response.stats, "Reported")).map(
    (stat) => ({ id: stat.name, count: stat.count }) as CountType,
  );
};

export const differentiateOptionsWithCount = (
  options: OptionType[],
  counts: CountType[],
) => {
  const valuesWithCount = compact(
    counts
      .filter((stat) => stat.count && stat.count > 0)
      .map((stat) => stat.id),
  );
  // if showCount is false, all options are put in optionsWithCount variable
  const optionsWithCount = getOptionsWithCount(
    options.filter(
      (option) =>
        valuesWithCount.includes(option.id) ||
        valuesWithCount.includes(`${option.id}`),
    ),
    counts,
  );
  const optionsWithoutCount = getOptionsWithCount(
    options.filter(
      (option) =>
        !(
          valuesWithCount.includes(option.id) ||
          valuesWithCount.includes(`${option.id}`)
        ),
    ),
    counts,
  );
  return {
    optionsWithCount,
    optionsWithoutCount,
  };
};
